export const defaultLocale = "de";
export const locales = [defaultLocale];
//export const locales = [defaultLocale, "en"];
export const defaultNS = "common";
export const localePrefix = "always";

// The `pathnames` object holds pairs of internal
// and external paths, separated by locale.
/*
  // Dynamic params are supported via square brackets
  '/news/[articleSlug]-[articleId]': {
    en: '/news/[articleSlug]-[articleId]',
    de: '/neuigkeiten/[articleSlug]-[articleId]'
  },

  // Also (optional) catch-all segments are supported
  '/categories/[...slugs]': {
    en: '/categories/[...slugs]',
    de: '/kategorien/[...slugs]'
  }
 */
export const pathnames = {
  // If all locales use the same pathname, a
  // single external path can be provided.
  "/": "/",

  // If locales use different paths, you can
  // specify each external path per locale.
  "/[slug]": "/[slug]",
  "/bookings": {
    //en: "/bookings",
    de: "/reservierung",
  },
  "/bookings/[slug]": {
    //en: "/bookings/[slug]",
    de: "/reservierung/[slug]",
  },
  "/posts/[slug]": {
    //en: "/news/[slug]",
    de: "/nachrichten/[slug]",
  },
  "/themes": {
    //en: "/themes",
    de: "/themen",
  },
  "/themes/[slug]": {
    //en: "/themes/[slug]",
    de: "/themen/[slug]",
  },
  "/destinations": {
    de: "/reiseziele",
  },
  "/destinations/[slug]": {
    de: "/reiseziele/[slug]",
  },
};
